"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DUMMY_MONTHS = void 0;
var util_1 = require("containers/Onboarding/TransactionPopup/util");
var today = new Date();
var thisMonth = today.getMonth();
var thisYear = today.getFullYear();
var dummyMonthsThisYear = __spreadArray([], __read(Array(thisMonth + 1).keys()), false).map(function (x) { return x + 1; })
    .map(function (month) { return ({
    label: util_1.monthLabels[month],
    yM: { year: thisYear, month: thisMonth },
    spend: 0,
    count: 0,
}); });
var dummyMonthsLastYear = __spreadArray([], __read(Array(12 - thisMonth).keys()), false).map(function (x) { return x + 1 + thisMonth; })
    .map(function (month) { return ({
    yM: { year: thisYear - 1, month: month },
    label: util_1.monthLabels[month],
    spend: 0,
    count: 0,
}); });
exports.DUMMY_MONTHS = dummyMonthsLastYear.concat(dummyMonthsThisYear);
